import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { Link, Navigate, useParams } from 'react-router-dom'
import CinematicNav from '../components/landing/CinematicNav'
import { useActiveIntake } from '../hooks/useActiveIntake'
import { findWork, publishedWork } from '../data/showcaseCatalog'

export default function ShowcaseProjectPage() {
  const { slug } = useParams()
  const project = findWork(slug)
  const { intake, fallback } = useActiveIntake()
  const [videoFailed, setVideoFailed] = useState(false)
  const related = publishedWork().filter((item) => item.slug !== slug && item.filter === project?.filter).slice(0, 3)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [slug])

  if (!project) return <Navigate to="/showcase" replace />

  return (
    <div className="cinema-page min-h-screen selection:bg-cinema-glow/30 selection:text-white">
      <Helmet>
        <title>{`${project.title} | SMA Showcase`}</title>
        <meta name="description" content={project.description || project.caption} />
        <link rel="canonical" href={`https://synergymultimediaacademy.com/showcase/${project.slug}`} />
      </Helmet>
      <div className="cinema-grain" aria-hidden="true" />
      <CinematicNav scrolled navOverHero={false} onNavigate={() => {}} intake={intake} fallback={fallback} />

      <main className="max-w-[1536px] mx-auto px-4 sm:px-6 lg:px-8 xl:px-12 pt-28 pb-20 sm:pt-32">
        <Link to="/showcase" className="inline-flex min-h-11 items-center text-[0.68rem] uppercase tracking-[0.2em] text-cinema-gold font-sans">
          ← Back to Showcase
        </Link>
        <p className="mt-8 text-[0.7rem] uppercase tracking-[0.22em] text-cinema-gold font-sans">{project.filter}</p>
        <h1 className="mt-3 max-w-4xl font-display text-4xl sm:text-6xl text-white font-light tracking-tight">{project.title}</h1>
        {project.creator && (
          <p className="mt-4 text-sm text-cinema-soft font-sans">Created by {project.creator}</p>
        )}
        {project.description && (
          <p className="mt-4 max-w-xl text-sm sm:text-base text-cinema-muted font-sans leading-relaxed">{project.description}</p>
        )}

        <div className="mt-10 bg-cinema-charcoal" style={{ aspectRatio: project.youtubeId ? '16 / 9' : project.ratio || '16 / 10' }}>
          {project.youtubeId && !videoFailed ? (
            <iframe
              className="w-full h-full"
              src={`https://www.youtube.com/embed/${project.youtubeId}`}
              title={project.title}
              allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              onError={() => setVideoFailed(true)}
            />
          ) : project.youtubeId && videoFailed ? (
            <div className="h-full min-h-[240px] flex flex-col justify-end p-6">
              <p className="font-display text-2xl text-white font-light">{project.title}</p>
              <p className="mt-2 text-sm text-cinema-muted font-sans">Video unavailable</p>
            </div>
          ) : (
            <img src={project.src} alt={project.alt} className="w-full h-full object-contain bg-black" />
          )}
        </div>

        {related.length > 0 && (
          <div className="mt-16 border-t border-white/10 pt-8">
            <p className="text-[0.65rem] uppercase tracking-[0.18em] text-cinema-muted font-sans">Related work</p>
            <ul className="mt-4">
              {related.map((item) => (
                <li key={item.slug} className="border-b border-white/10">
                  <Link to={`/showcase/${item.slug}`} className="flex items-baseline justify-between gap-4 py-4 min-h-11">
                    <span className="font-display text-2xl text-white font-light">{item.title}</span>
                    <span className="text-[0.65rem] uppercase tracking-[0.16em] text-cinema-gold font-sans">{item.filter}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        )}
      </main>
    </div>
  )
}
